module.exports = __webpack_public_path__ + "img/11_u31.43474d29.svg";